import React from 'react';
import css from './Banner.module.css';
import classNames from 'classnames';

const Banner = props => {
  const { desktopImg, mobileImg, text, description, showBoldTitle } = props;
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 1025;
  const bannerCover = isMobile ? mobileImg : desktopImg;

  return (
    <div className={css.wrapper}>
      <div className={css.bannerContent}>
        <p
          className={classNames(css.heading, {
            [css.boldTitle]: showBoldTitle,
          })}
          dangerouslySetInnerHTML={{
            __html: text,
          }}
        />
        <p className={css.description}>{description}</p>
      </div>
      <img src={bannerCover} className={css.cover} />
    </div>
  );
};

export default Banner;
